var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 58 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.42 49.63a1.8 1.8 0 0 1 2.55.04 10.7 10.7 0 0 0 10.67 2.87 10.8 10.8 0 0 0 7.55-8.11 1.8 1.8 0 1 1 3.53.78 14.43 14.43 0 0 1-10.1 10.83 14.28 14.28 0 0 1-14.24-3.83c-.7-.72-.68-1.88.04-2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m50.32 2.9-10.8 7.91L24.26 0 13.13 15.23.55 11.2l7.13 21.9v.61a7.73 7.73 0 0 0-7.37 7.7c0 4.26 3.42 7.7 7.63 7.7h.56C11.04 57.73 19.27 64 29 64s17.96-6.28 20.5-14.88h.8a7.67 7.67 0 0 0 7.39-7.7v-.26a7.67 7.67 0 0 0-7.37-7.45V2.89ZM11.4 33.42l-.03 10.05c0 9.14 7.69 16.62 17.29 16.8H29c9.65 0 17.45-7.37 17.63-16.48V27.48L11.4 33.43ZM54 41.41a3.97 3.97 0 0 1-3.68 3.98v-7.96l.4.05A3.98 3.98 0 0 1 54 41.41ZM7.48 37.45l.2-.02v7.96A3.97 3.97 0 0 1 4 41.4a3.97 3.97 0 0 1 3.48-3.96Z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c267e6911af253b1d2333ef3650a9869.svg";
export { ForwardRef as ReactComponent };